module.exports = __webpack_public_path__ + "img/login5.dcf2570e.png";